/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Total_SignalsInputs */

const en_total_signals = /** @type {(inputs: Total_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Signals`)
};

const es_total_signals = /** @type {(inputs: Total_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Señales totales`)
};

const fr_total_signals = /** @type {(inputs: Total_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signaux totaux`)
};

const de_total_signals = /** @type {(inputs: Total_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamte Signale`)
};

const ja_total_signals = /** @type {(inputs: Total_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`総シグナル数`)
};

const zh_total_signals = /** @type {(inputs: Total_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总信号数`)
};

const ar_total_signals = /** @type {(inputs: Total_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجمالي الإشارات`)
};

const id_total_signals = /** @type {(inputs: Total_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Sinyal`)
};

const it_total_signals = /** @type {(inputs: Total_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segnali Totali`)
};

const ru_total_signals = /** @type {(inputs: Total_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всего сигналов`)
};

const pt_total_signals = /** @type {(inputs: Total_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de Sinais`)
};

const ko_total_signals = /** @type {(inputs: Total_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`총 시그널 수`)
};

/**
* | output |
* | --- |
* | "Total Signals" |
*
* @param {Total_SignalsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const total_signals = /** @type {((inputs?: Total_SignalsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Total_SignalsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_total_signals(inputs)
	if (locale === "es") return es_total_signals(inputs)
	if (locale === "fr") return fr_total_signals(inputs)
	if (locale === "de") return de_total_signals(inputs)
	if (locale === "ja") return ja_total_signals(inputs)
	if (locale === "zh") return zh_total_signals(inputs)
	if (locale === "ar") return ar_total_signals(inputs)
	if (locale === "id") return id_total_signals(inputs)
	if (locale === "it") return it_total_signals(inputs)
	if (locale === "ru") return ru_total_signals(inputs)
	if (locale === "pt") return pt_total_signals(inputs)
	return ko_total_signals(inputs)
});